import { becomeDealerData } from "@/utils/staticData/becomeDealer";

import Section from "@/components/Section";
import Stepper from "@/components/UI-Kit/Stepper";
import { Typography } from "@mui/material";

const BecomeDealerStepper = () => {
  return (
    <Section pt={{ xs: 0, md: 8, lg: 12.5 }} pb={{ xs: 7.5, md: 8, lg: 12.5 }}>
      <Typography
        variant="h2"
        mb={{ xs: 2, md: 3 }}
        textAlign={{ xs: "start", md: "center" }}
        id="becomeDealerSection"
      >
        Getting Started with Trackmate
      </Typography>
      <Typography
        variant="subtitle1"
        component="p"
        color="text.secondary"
        textAlign={{ xs: "start", md: "center" }}
        mb={{ xs: 4, md: 10 }}
      >
        Our process is designed to help you achieve value quickly. Start by filling out our simple form.
      </Typography>

      <Stepper steps={becomeDealerData} type="dealer" />
    </Section>
  );
};

export default BecomeDealerStepper;
